// extracted by mini-css-extract-plugin
export var cardimage = "ExternalSignPostCard-module--cardimage--bed3a";
export var cardsubtitletext = "ExternalSignPostCard-module--cardsubtitletext--1c18a";
export var cardwrapper = "ExternalSignPostCard-module--cardwrapper--dcf35";
export var cardwrapperwithimage = "ExternalSignPostCard-module--cardwrapperwithimage--07aef";
export var linkwrapper = "ExternalSignPostCard-module--linkwrapper--4392e";
export var title = "ExternalSignPostCard-module--title--10a5f headings-module--signpostHeadingSmall--e67c4";